import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WorkflowStatus } from '../modules/shared/models';

@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FilterDialogComponent implements OnInit,OnDestroy{
  filterForm: FormGroup = new FormGroup({});
  // _urlSub?: Subscription;
  isGroup: boolean = false;
  public workflowStatus = WorkflowStatus;
  constructor(public dialogRef: MatDialogRef<FilterDialogComponent>,private router :Router, private fb: FormBuilder) {}
  ngOnDestroy(): void {
   //this._urlSub?.unsubscribe();
  }
 
  onCancel(): void {
    console.log('Cancel button clicked');
    this.dialogRef.close();
  }

  ngOnInit(): void {
 // Check current route on dialog open
  if (this.router.url.includes('group')) {
    this.isGroup = true;
  }
    //  this._urlSub = this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //    console.log('Navigation ended:', event.url);
    //    if (event.url.includes('group')) {
    //       this.isGroup = true;
    //     }
    //   }
    
    //   console.log('isGroup:..................', this.isGroup);
    // });
    this.filterForm = this.fb.group({
      filter: ['Client Name' ],
      search: ['', ],
      RAG: this.fb.group({
    Red: [false],
    Grey: [false],
    Amber: [false],
      Green: [false]
  })
    });

    this.filterForm.get('filter')?.valueChanges.subscribe((value) => {
      console.log('Selected filter:', value); // Debugging log
    });
  }

  get Red() {
    return this.filterForm.get('RAG.Red') as FormControl;
  }
  get Grey() {
    return this.filterForm.get('RAG.Grey') as FormControl;
  }
  get Amber() {
    return this.filterForm.get('RAG.Amber') as FormControl;
  }
  get Green() {
    return this.filterForm.get('RAG.Green') as FormControl;
  }

  onApply(): void {
    if (this.filterForm.valid) {
      const filterValues = this.filterForm.value;
      // To get selected rag colors as an array:
      const ragColorObj = filterValues.RAG;
      const selectedRagColors = Object.keys(ragColorObj).filter(key => ragColorObj[key]);
      console.log('Selected Rag Colors:', selectedRagColors);
      this.dialogRef.close({ ...filterValues, selectedRagColors });
    }
  }
}
